<form [formGroup]="parentForm">
  <div class="container" formGroupName="iconResource">
    <mat-form-field class="hint">
      <input matInput placeholder="Resource Path" autocomplete="off" formControlName="resourcePath" required />
      <mat-hint>The path on the event to extract the value to be used for checking icon type</mat-hint>
    </mat-form-field>
    <ng-container formGroupName="defaultIcon">
      <h2>Default Icon</h2>
      <p>This icon will be displayed on a post if it does not match any configured types for custom icons below</p>

      <mat-radio-group aria-label="Icon Type" formControlName="format">
        <mat-radio-button value="matIcon">Mat Icon</mat-radio-button>
        <mat-radio-button value="iconPath">Icon Url</mat-radio-button>
      </mat-radio-group>
      <mat-form-field class="hint">
        <input matInput placeholder="Value" autocomplete="off" formControlName="value" required />
        <mat-hint>The mat icon name or the url to an icon</mat-hint>
      </mat-form-field>
    </ng-container>
    <h2>Custom Types</h2>
    <p>Custom icons can be displayed for different posts depending on the value in the resource path</p>
    @for (customType of customTypes.controls; track customType; let i = $index) {
      <mat-card appearance="outlined" class="custom-type">
        <div class="container custom-type-form">
          <mat-form-field class="hint">
            <input matInput placeholder="Type" autocomplete="off" [formControl]="customType.get('type')" />
            <mat-hint>The type that must be in the resource path in order for this icon to be used</mat-hint>
          </mat-form-field>
          <mat-radio-group aria-label="Icon Format" [formControl]="customType.get('icon').get('format')">
            <mat-radio-button value="matIcon">Mat Icon</mat-radio-button>
            <mat-radio-button value="iconPath">Icon Url</mat-radio-button>
          </mat-radio-group>
          <mat-form-field class="hint">
            <input
              matInput
              placeholder="Value"
              autocomplete="off"
              [formControl]="customType.get('icon').get('value')"
              required
              />
            <mat-hint>The mat icon name or the url to an icon</mat-hint>
          </mat-form-field>
        </div>
        <button mat-icon-button>
          <mat-icon aria-label="Remove" (click)="removeCustomType($event, i)" matTooltip="Remove">clear</mat-icon>
        </button>
      </mat-card>
    }
    <button class="add" mat-button (click)="addCustomType($event)">+ Add Custom Type</button>
  </div>
</form>
